import { type JSX } from "react";

import { useTranslation } from "react-i18next";

/**
 * A full screen component that shows a loading indicator and a message that we are waiting for the tenant id
 */
export function WaitingForTenant(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center">
      <div className="text-2xl font-semibold">
        {t("core.waitingForTenantHeading")}
      </div>
      <div className="text-sm text-gray-600">
        {t("core.waitingForTenantSubheading")}
      </div>
    </div>
  );
}

export function TenantNotFound(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center">
      <div className="text-2xl font-semibold text-red-500">
        {t("core.tenantNotFoundHeading")}
      </div>
    </div>
  );
}
